export default __webpack_public_path__ + "static/media/the_goal_is_to_be_wrong_in_interesting_ways.0e5bf7bf.png";